var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/svg-macros.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
[], 
["href", "classes"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("href", kwargs.hasOwnProperty("href") ? kwargs["href"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("classes", kwargs.hasOwnProperty("classes") ? kwargs["classes"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_2 = "";t_2 += "<svg ";
if(runtime.contextOrFrameLookup(context, frame, "classes")) {
t_2 += "class=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classes"), env.opts.autoescape);
t_2 += "\"";
;
}
t_2 += "><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "href"), env.opts.autoescape);
t_2 += "\"></use></svg>";
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("linkedSvg");
context.setVariable("linkedSvg", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/svg-macros.j2"] , dependencies)